// extracted by mini-css-extract-plugin
module.exports = {"container":"SUiVmO1MKFM2vDPj58pso"};